import PasswordChangeRequiredPage from "components/pages/PasswordChangeRequiredPage";

/**
 * @name CaptureSoftTokenActivationActivateTokenPasswordChange
 * @returns {React.Component}
 * @description A capture component in the capture group "Soft Tokens - Activation".
 */
export default function CaptureSoftTokenActivationActivateTokenPasswordChange(props) {
    return <PasswordChangeRequiredPage />;
}